// Central content store, edit copy, placeholders and imagery here.

export const LOGO =
  "https://customer-assets-0z36b82j.emergentagent.net/job_laura-mcllelland/artifacts/zwt63icr_8b882aaa-a5d0-4c8a-9893-42aad47651a8.png";

export const CALENDLY_URL = "https://calendly.com/lmmclelland/cranio-session";

export const CALENDLY_INITIAL_URL = "https://calendly.com/lmmclelland/initial-cranio-session";

export const CALENDLY_SESSIONS = [
  {
    id: "initial",
    label: "Initial Cranio Session",
    duration: "90 minutes",
    url: "https://calendly.com/lmmclelland/initial-cranio-session",
    description:
      "For new clients, a spacious first visit with time for intake conversation and a full hands-on session.",
  },
  {
    id: "60min",
    label: "1-Hour Cranio Session",
    duration: "60 minutes",
    url: "https://calendly.com/lmmclelland/cranio-session",
    description:
      "A full restorative session, ideal for returning clients settling into a rhythm of care.",
  },
  {
    id: "30min",
    label: "30-Minute Mini Session",
    duration: "30 minutes",
    url: "https://calendly.com/lmmclelland/30min",
    description:
      "A focused check-in for returning clients, perfect for maintenance visits or a gentle reset.",
  },
];

export const SITE = {
  name: "Cranio Cove",
  tagline: "Craniosacral Therapy",
  heroTagline: "A gentle approach to healing. Deeply relaxing. Naturally restoring.",
  siteTagline: "Gentle, intuitive care for your body, mind, and nervous system.",
  siteIntro:
    "Cranio Cove offers safe, trauma-informed, client-centered care. Together, we'll support your nervous system, release stored tension, and restore balance, one session at a time.",
  practitioner: "Laura McLelland",
  city: "Tarrytown",
  region: "NY",
  cityRegion: "Tarrytown, NY",
  email: "lmmclelland@craniocove.com",
  phone: "914.417.9223",
  phoneHref: "+19144179223",
  address: "The Hearth by Well Wombn, 200 S. Broadway, Building 1, Suite 100, Tarrytown, NY 10591",
  serviceArea: "the Rivertowns and greater Westchester, NY area",
  googleReviewUrl: "https://g.page/r/placeholder/review",
  hearthUrl: "https://wellwombn.com",
  hearthName: "The Hearth by Well Wombn",
  payments: ["Cash", "Check", "Venmo", "Zelle"],
  hours: [
    { day: "Wednesday", time: "10:00am – 6:00pm" },
    { day: "Other days", time: "By appointment" },
  ],
  availabilityNote:
    "Cranio Cove is located within The Hearth by Well Wombn, 200 S. Broadway, Building 1, Suite 100, Tarrytown, NY 10591.",
  url: "https://craniocove.com",
};

export const IMAGES = {
  heroWater: "https://images.pexels.com/photos/32610550/pexels-photo-32610550.jpeg",
  therapyRoom: "https://images.pexels.com/photos/17709394/pexels-photo-17709394.jpeg",
  coveTurquoise: "/covephotos/42c44dfe-6735-4cc9-adf4-9d23a09819b4.png",
  coveBeach: "/covephotos/5295a6ce-7a32-418a-bee6-95425ee5701c.png",
  coveSunsetPurple: "/covephotos/7cf474ce-84e8-40ba-ac92-8c818408cc49.png",
  coveHarbor: "/covephotos/a9a41165-1cd3-41f0-8dc8-04c96fc13f54.png",
  covePines: "/covephotos/c4b8544c-6f91-4faa-9f2f-5a137158f448.png",
  coveMarina: "/covephotos/ce8d0e45-5746-4590-b0a1-1459fea683ad.png",
  coveMoody: "/covephotos/fda69751-d6f6-4c42-a136-f565a0e45c77.png",
  coveDockPink: "/pics/IMG_4489.JPEG",
  coveClouds: "/pics/IMG_4605.jpeg",
  coveBlueSky: "/pics/IMG_6017.jpeg",
  coveBrightSky: "/pics/IMG_6022.jpeg",
  coveGolden: "/pics/IMG_8315.JPG",
  coveMagenta: "/pics/IMG_8327.JPG",
  coveExpect: "/pics/expect-sunset.webp",
  lauraPortrait: "/laura/laura-portrait.jpg",
  lauraCandid: "/laura/laura-candid.jpg",
  lauraStudio: "/laura/laura-studio.jpg",
  sandWater: "https://images.unsplash.com/photo-1694530962888-601f0782307a",
  waves: "https://images.unsplash.com/photo-1784982090927-c47b40ccf794",
  softGrass: "https://images.unsplash.com/photo-1518495973542-4542c06a5843",
  mist: "https://images.unsplash.com/photo-1470252649378-9c29740c9fa8",
  forestLight: "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d",
  beachSunset: "https://customer-assets-0z36b82j.emergentagent.net/job_laura-mcllelland/artifacts/aj0f5bdz_d2df06f5-dd8a-4542-aa24-fe874415867f.png",
  heroComposite: "https://customer-assets-0z36b82j.emergentagent.net/job_laura-mcllelland/artifacts/1ru8v61h_de3d5468-2313-4baf-98b8-6c5c0e9f700d.png",
  healingSection: "https://customer-assets-0z36b82j.emergentagent.net/job_laura-mcllelland/artifacts/ambha9hm_05d60b48286e1b2777f12677a57e38c87a3910f0b59d7644f2b1c53fe54d1f2b.png",
};

export const SUPPORT = [
  { icon: "sparkles", title: "Relax & Reset", body: "Release stress and tension while supporting your nervous system to rest and restore." },
  { icon: "sun", title: "Restore Balance", body: "Support your body's natural rhythms and improve your overall sense of well-being." },
  { icon: "moon", title: "Deep Healing", body: "Gently address the root of discomfort and held tension with profound, patient care." },
];

export const AFTERCARE = [
  { title: "Move gently", body: "Give yourself permission to slow down for the rest of the day. Light stretching or a quiet walk can help the work settle." },
  { title: "Hydrate & rest", body: "Drink plenty of water and allow for extra rest. Deep relaxation can leave you feeling calm, dreamy, or pleasantly tired." },
  { title: "Notice softly", body: "You may notice subtle shifts over the following days. There's nothing to fix, simply observe with curiosity and kindness." },
  { title: "Be patient", body: "Healing is a process, not an event. Small, gentle changes often unfold quietly between sessions." },
];

export const QUOTE = {
  text: "The body has a deep intelligence. When we create the space, it knows how to heal.",
  author: "",
};

export const ABOUT = {
  intro: [
    "I am an Occupational Therapist and Craniosacral Practitioner with over a decade of experience in healthcare, as well as twenty years in business. I bring both medical insight and intuitive presence to every session.",
    "My work blends the art and science of healing, honoring the body's wisdom while addressing the nervous system, fascia, and subtle energy body with care and intention.",
  ],
  script: "You deserve to feel better",
  mission:
    "At Cranio Cove, I help individuals of all ages find relief from trauma, stress, chronic conditions, and emotional overwhelm by regulating the nervous system with Craniosacral Therapy (CST). Whether you're navigating anxiety, recovering from injury, suffering from chronic pain and inflammation, processing grief, or simply seeking deeper alignment, my mission is to hold a safe, compassionate space for your healing.",
  approach: [
    "Sessions are tailored to my clients' unique needs, of all ages and stages.",
    "I combine trauma-informed care with deep listening and intuitive touch.",
    "My goal is whole-body transformation that lasts, not just temporary relief as a band-aid.",
  ],
  journeyHeading: "Why I do this work",
  journey: [
    "In my mid-20s, I suffered an accident resulting in a severe back injury. I had back surgery at 25 and tried all the traditional pain management treatments.",
    "It wasn't until I found craniosacral therapy after a health crisis in my late 40s that my chronic, debilitating pain began to alleviate. I now have no back pain, after suffering for over 20 years.",
    "Craniosacral therapy has been instrumental in guiding me through illness, pain, grief, hormonal changes, and nervous system regulation.",
    "This is why I became a craniosacral practitioner. It is my passionate mission to help guide others on their path to healing.",
  ],
  credentials: [
    { title: "Occupational Therapist", items: ["Master's of Science in Occupational Therapy, 2014", "Licensed since 2014"] },
    { title: "Upledger Craniosacral Therapy", items: ["CST I", "CST II", "SomatoEmotional Release (SER)", "Pediatric Craniosacral Therapy"] },
    { title: "Dynamic Body Balancing", items: ["Certification Levels 1–5"] },
    { title: "Additional Studies", items: ["Currently training in Feng Shui and energetic wellness"] },
  ],
  philosophyQuote: "Healing is more than just fixing what's broken, it's about creating the conditions where the body remembers how to heal itself.",
  philosophy: [
    "I believe in treating the whole person, not just the symptoms. Every session is tailored to you, your needs, and your goals.",
    "With presence, compassion, and gentle touch, I help you reconnect with your body's innate intelligence so you can feel more calm, resilient, and aligned.",
  ],
  closing: "Your body holds the wisdom. My role is simply to help you listen.",
  reviewCta: {
    heading: "Did you enjoy your session?",
    body: "Please consider leaving a positive Google review. Your kind words make a huge impact for a small business and for other clients searching for excellent care.",
    signoff: "With much gratitude, Laura",
  },
};

// What is CST, the fuller, page-level description
export const CST = {
  overline: "Gentle. Intentional. Profound.",
  intro: [
    "Craniosacral Therapy (CST) is a gentle, non-invasive, hands-on modality, which works with the membranes and cerebrospinal fluid that surround your brain and spinal cord. Using light, intentional touch, we assess for restrictions in the fascia (connective tissue which wraps around every organ, muscle, nerve, bone) and gently guide the body back into alignment by releasing restrictions in the pelvis, spine, neck, and skull, which in turn, improves the function of the central nervous system.",
    "This process supports the nervous system, boosts immune function, and creates space for the body to self-heal and release deeply held tensions, in your physical, emotional, and energetic body. CST helps to realign the body, quiet the mind, and invite deep, profound transformation.",
  ],
};

// Benefits of CST, used on Therapy page (and optionally Home)
export const BENEFITS = [
  "Relief from chronic pain, fatigue, and stress-related symptoms",
  "Release stored tension, trauma, and emotion",
  "A deep sense of calm and regulation",
  "Transition from \"fight-or-flight\" to \"rest-and-restore\"",
  "Somatic (body-based) integration of spiritual and emotional insight",
  "Gentle support for grief, anxiety, postpartum recovery, and more",
];

// Conditions CST can help with, used on Therapy page
export const CONDITIONS_INTRO =
  "Over time, daily stresses & strains accumulate in the body, creating chronic tension & restricting the natural rhythm of the craniosacral system, potentially affecting the function of your central nervous system (CNS). This may lead to a variety of health concerns. CST has been shown to help people with a wide spectrum of pain and dysfunction, including, but not limited to:";
export const CONDITIONS = [
  "Alzheimer's",
  "Central Nervous System Disorders",
  "Chronic Fatigue",
  "Chronic Neck & Back Pain",
  "Fibromyalgia",
  "Immune Disorders",
  "Learning Differences, ADD, ADHD",
  "Migraines & Headaches",
  "Orthopedic Problems",
  "Post-Concussion Symptoms",
  "Post-Traumatic Stress Disorders",
  "Scoliosis",
  "Stress & Tension-Related Disorders",
  "TMJ Syndrome",
  "& many other conditions",
];
export const CONDITIONS_NOTE =
  "*Benefits are accumulative and a series of sessions are recommended.";

// What to expect DURING a session (reworded)
export const IN_SESSION = [
  "You'll remain fully clothed in comfortable attire.",
  "You'll rest comfortably on a massage table.",
  "Light touch may be applied to the head, spine, sacrum, feet, or any area needing extra attention.",
  "You're invited to simply rest or connect inward, however you feel most supported.",
];
export const IN_SESSION_CLOSING =
  "Each session is held with presence and intention to create space for your body's own wisdom to lead the way.";

// After a session, common experiences
export const POST_SESSION_INTRO =
  "Your body is complex and miraculous. Trauma causes chronic stress and overall inflammation. Craniosacral therapy works to unwind and release stress, reduce inflammation, and promote relaxation, helping your body to heal.";
export const POST_SESSION_LEAD =
  "Here's what to expect and how to support yourself in the hours and days following your session. Each person responds differently, but some common post-session experiences include:";
export const POST_SESSION = [
  "A sense of calm, clarity, and increased energy.",
  "Minor body aches or fatigue (this is normal and temporary!).",
  "Emotional release, such as tears, mood shifts, or vivid dreams.",
  "Subtle internal sensations, such as tissue twitching, vibrations, or warmth.",
  "A feeling of reconnecting with your body.",
  "A surge of energy, or the need for rest and relaxation.",
];
export const POST_SESSION_NOTE =
  "These are all positive signs that your system is responding, releasing, and rebalancing.";

// Why This Happens
export const WHY_HAPPENS_INTRO =
  "CST works by gently releasing tension in the fascia and regulating your nervous system. As your body unwinds, it may need time to:";
export const WHY_HAPPENS = [
  "Detoxify (via lymphatic movement).",
  "Process emotional or energetic shifts.",
  "Adjust to new postural or structural alignment.",
];
export const WHY_HAPPENS_NOTE =
  "Think of it like hitting \"reset\", things may feel a little different at first, but your body is recalibrating in a healthy way.";

// Support Your Healing, 5 self-care blocks
export const SUPPORT_HEALING = [
  {
    title: "Rest when you can",
    body: "Avoid intense exercise or stressful environments. Allow your nervous system to settle and integrate.",
  },
  {
    title: "Gentle movement",
    body: "Walk or stretch. These activities promote circulation, support lymphatic drainage, and help integrate the deep work.",
  },
  {
    title: "Take a warm bath",
    body: "Try adding Epsom salts or calming essential oils like lavender or frankincense to soothe your muscles and mind.",
  },
  {
    title: "Hydrate",
    body: "Drink plenty of water. Hydration helps flush out toxins and prevents headaches or fatigue.",
  },
  {
    title: "Breathe & reflect",
    body: "Practice deep belly breathing, journal, or do something joyful. Let your body lead. Stay grounded, and notice what you feel.",
  },
];

// A Note on Other Therapies
export const OTHER_THERAPIES_NOTE =
  "If you're working with other healing modalities (like acupuncture, massage, chiropractic, or PT/OT), give your body space between sessions, ideally at least one week, to avoid overloading your system.";

// Your Healing is a Journey (Laura's closing note)
export const HEALING_JOURNEY = {
  heading: "Your healing is a journey.",
  body: [
    "Most people benefit from a series of CST sessions, especially when healing long-term, chronic, or complex conditions. Each visit builds on the last. Your feedback helps guide future sessions and ensures we're supporting your unique healing process.",
    "Be kind and patient with your body as you walk this beautiful journey. I will be right there beside you. Thank you for trusting me to walk with you.",
  ],
  signoff: "With gratitude, Laura",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About Laura", to: "/about" },
  { label: "The Therapy", to: "/craniosacral-therapy" },
  { label: "What to Expect", to: "/what-to-expect" },
  { label: "Services", to: "/services" },
  { label: "FAQ", to: "/faq" },
  { label: "Intake Form", to: "/intake" },
  { label: "Contact", to: "/contact" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Pause",
    body: "Arrive without agenda. The cove is a quiet room away from the noise of the day, held warm and unhurried so your system can begin to slow.",
  },
  {
    num: "02",
    title: "Settle",
    body: "Through light, attentive contact, the body is invited to release what it has been holding, not forced, only gently supported toward ease.",
  },
  {
    num: "03",
    title: "Reconnect",
    body: "As the nervous system finds a steadier rhythm, many people notice a softer, more present sense of being at home in their own body.",
  },
];

export const REASONS = [
  "Ongoing tension in the back, head, neck, jaw or shoulders",
  "Feeling wired, restless, or unable to fully switch off",
  "Recovering from periods of stress or overwhelm",
  "Difficulty settling into deep, restful sleep",
  "A wish for quiet, restorative time for the body",
  "Curiosity about gentle, hands-on nervous system care",
];

export const DIFFERENCE = [
  {
    title: "Unhurried, one-to-one time",
    body: "Every session is private and individually paced. There is no template, the work follows what your body is ready for that day.",
  },
  {
    title: "A trauma-aware, consent-led approach",
    body: "Comfort and choice come first. You are welcome to speak, adjust, or pause at any point, and nothing happens without your agreement.",
  },
  {
    title: "A genuinely calm environment",
    body: "A softly lit private room, warm surfaces and quiet, a considered space designed to help you feel safe enough to let go.",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Booking",
    body: "Book your session directly through the online calendar, or send Laura a message with any questions before you reserve a time.",
  },
  {
    num: "02",
    title: "The session",
    body: "You rest comfortably and fully clothed on a padded table. Using light contact, Laura listens to the subtle rhythms of the body and supports it toward ease.",
  },
  {
    num: "03",
    title: "Integration",
    body: "We allow a few gentle minutes to return before you leave. Many people feel calm and a little dreamy, you're encouraged to keep the rest of your day soft.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I left feeling lighter than I have in months, like my whole system had finally exhaled. The space itself is so calming.",
    name: "Robin",
    detail: "Follow-up client",
  },
  {
    quote:
      "Laura is warm, attentive and completely unhurried. I always feel genuinely listened to, and never rushed.",
    name: "Teresa",
    detail: "Regular client",
  },
  {
    quote:
      "The gentlest hands-on work I've experienced. I didn't know rest could feel this deep. I look forward to every visit.",
    name: "Lauren",
    detail: "Initial session",
  },
];

export const MARQUEE = [
  "Pause",
  "Settle",
  "Reconnect",
  "Rest",
  "Softness",
  "Stillness",
  "Presence",
  "Ease",
];

export const SERVICES = [
  {
    id: "initial",
    name: "Initial Session",
    duration: "90 minutes",
    price: "$200",
    calendlyId: "initial",
    calendlyUrl: "https://calendly.com/lmmclelland/initial-cranio-session",
    description:
      "A gentle first visit that begins with an unhurried conversation about your history and hopes, followed by your first hands-on session.",
    features: ["Full intake & consultation", "First hands-on session", "Aftercare guidance"],
  },
  {
    id: "cranio",
    name: "Cranio Session",
    duration: "60 minutes",
    price: "$175",
    calendlyId: "60min",
    calendlyUrl: "https://calendly.com/lmmclelland/cranio-session",
    description:
      "A focused continuation of your care, building gently on previous sessions to support an increasingly settled nervous system.",
    features: ["Brief check-in", "Focused hands-on session", "Ongoing guidance"],
  },
  {
    id: "mini",
    name: "Mini Session",
    duration: "30 minutes",
    price: "$90",
    calendlyId: "30min",
    calendlyUrl: "https://calendly.com/lmmclelland/30min",
    description:
      "A shorter, targeted session, ideal as a gentle reset between longer visits or for returning clients maintaining a rhythm.",
    features: ["Quick check-in", "Focused hands-on work", "Great for maintenance"],
  },
];

// Session packages, a bundled option outside the main 3 tiles
export const PACKAGES = [
  {
    id: "pkg-5",
    name: "Package of 5 sessions",
    price: "$825",
    priceNote: "≈ $165 per session",
    description:
      "A committed rhythm of care for those working through longer-term, chronic, or complex conditions. Save when you plan ahead.",
  },
];

export const FAQS = [
  {
    q: "What is craniosacral therapy?",
    a: "Craniosacral therapy is a gentle, hands-on approach that uses light contact to support the body's natural capacity to heal and self-regulate. Sessions are calm and non-invasive, focusing on helping the nervous system settle.",
  },
  {
    q: "What should I wear? Do I remain clothed?",
    a: "Comfortable, loose clothing is ideal, you remain fully clothed for the entire session, so wear whatever helps you feel relaxed and at ease. The work involves light, respectful contact at points such as the head, back or feet, always with your consent.",
  },
  {
    q: "How long is a session?",
    a: "Sessions typically last between 30 and 90 minutes depending on the option you choose. Your first visit is a little longer to allow time for an initial conversation.",
  },
  {
    q: "Is craniosacral therapy massage?",
    a: "No. Unlike massage, there is no manipulation of muscles or deep pressure. The contact is very light, and the focus is on gently supporting the body rather than working the tissues.",
  },
  {
    q: "How many sessions will I need?",
    a: "This varies from person to person and depends on your individual goals. Some people enjoy occasional sessions, while others prefer a regular rhythm. Laura will happily discuss what might suit you.",
  },
  {
    q: "What might I experience during a session?",
    a: "Experiences differ. Many people feel deeply relaxed, notice warmth or subtle shifts, or simply drift into a restful state. There is no right way to respond, and you're welcome to share feedback at any time.",
  },
  {
    q: "Can craniosacral therapy replace medical treatment?",
    a: "No. Craniosacral therapy is a complementary, supportive practice and is not a substitute for medical care. It does not diagnose, treat or cure any medical condition. Please continue to consult your doctor for medical concerns.",
  },
  {
    q: "Is the practice accessible?",
    a: "Accessibility details for the practice are available on request, please get in touch and Laura will be glad to talk through arrangements to help your visit feel comfortable.",
  },
  {
    q: "Where is Cranio Cove located?",
    a: "Cranio Cove is located within The Hearth by Well Wombn, 200 S. Broadway, Building 1, Suite 100, Tarrytown, NY 10591. Serving the Rivertowns and greater Westchester, NY area.",
  },
  {
    q: "What is the cancellation policy?",
    a: "Please provide at least 24 hours' notice to reschedule or cancel a session. Full details are confirmed at the time of booking.",
  },
  {
    q: "How do I book an appointment?",
    a: "The quickest way is through the online scheduler, use the \"Book a Session\" button anywhere on this website to choose a session length and pick a time. If you'd rather ask a question first, email Laura directly at lmmclelland@craniocove.com and she'll reply personally.",
  },
];
